module.exports = __webpack_public_path__ + "assets/img/04f4978a42e78236767594783f097f5d.png";